import type { OrganizationList } from 'models';
import { Card, Icon } from 'ui';
import { DetailsOrganization } from './details-organization';

type P = {
  organization: OrganizationList;
};

const DetailsCard = ({ organization }: P) => (
  <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
    <DetailsOrganization organization={organization} />
  </Card>
);

export default DetailsCard;
